




































import {
  NotaryProductDocument,
  NotaryProductTypeSlug
} from '@ligo/dashboard/store';
import { defineComponent, PropType } from '@vue/composition-api';
import DocumentNameClickable from '../../global/DocumentNameClickable.vue';
import { APrimaryBtn } from '../../base/app/buttons';

export default defineComponent({
  name: 'ItemPending',
  components: { DocumentNameClickable, APrimaryBtn },
  props: {
    item: {
      type: Object as PropType<NotaryProductDocument>,
      required: true
    },
    productType: {
      type: String as PropType<NotaryProductTypeSlug>
    }
  }
});
